/*
 * Purpose : Common component for view item for view screens
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react'
import { Col } from "reactstrap";

const ViewItem = (props) => {
    return (
        <Col sm={props.width} md={props.width}>
            <dl style={{borderLeft:"outset", paddingLeft:"3%",marginBottom:"1.5rem"}}>
                <dt style={{color:"#545b64"}}>{props.tag}</dt>
                <dd style={{wordBreak:"break-word", fontSize:"smaller"}}>{props.value?props.value:"_"}</dd>
            </dl>
        </Col>
    )
}

export default ViewItem
